import { FileClient } from "clients/rest";

export type B100193ExcelRequest = Partial<{
  locationCdFrom: string;
  locationCdTo: string;
}>;

export const B100193GetExcel = (props: B100193ExcelRequest) => {
  return FileClient.get("b100193/get/excel", {
    params: props,
  });
};
